export interface ICheckStatus {
  /** Дата проверки **/
  date: string;
  /** Статус надежности **/
  status: EStatus;
  /** Заголвок **/
  title: string;
}
export enum EStatus {
  /** Неудача **/
  'Problem' = 'problem',
  /** Успех **/
  'Reliable' = 'reliable',
}
